import React from 'react'
import { Card } from 'plume-ui'
import { IpoSummary } from '../../../types'
import { CardInnerTitle } from '../../atoms/CardInnerTitle'
import { Table, TableHeading, TableCell, SubLabel } from '../../atoms/Table'
import { A } from '../../atoms/A'
import { formatWithComma } from '@/lib/number'
import { EmptyCard } from '../../common/EmptyCard'
import { Help } from '../../common/Help'

type Props = {
  list: IpoSummary[]
  className?: string
}

export const IpoSummaryList: React.FC<Props> = (props) => {
  return (
    <Card className={props.className}>
      <CardInnerTitle title="投資サマリー（IPO企業）一覧" />
      {props.list.length > 0 ? (
        <Table>
          <thead>
            <tr>
              <TableHeading>スタートアップ</TableHeading>
              <TableHeading>
                IPO直前株数
                <Help>IPO直前の所有株数(潜在株を含む)</Help>
              </TableHeading>
              <TableHeading>
                シェア
                <Help>IPO直前の所有株式(潜在株式を含む)の割合%</Help>
              </TableHeading>
              <TableHeading>
                投資額
                <SubLabel>千円</SubLabel>
                <Help>
                  {`IPOまでに投資した金額(株式を譲受した場合は取得額を投資額に加算、\n譲渡した場合は売却額を投資額から減額)`}
                </Help>
              </TableHeading>
              <TableHeading>
                平均株価
                <SubLabel>円</SubLabel>
                <Help>
                  {`投資金額合計(株式を譲受した場合は取得額を投資額に加算、\n譲渡した場合は売却額を投資額から減額)÷全株数`}
                </Help>
              </TableHeading>
              <TableHeading>備考</TableHeading>
            </tr>
          </thead>
          <tbody>
            {props.list.map((summary, i) => (
              <tr key={i}>
                <TableCell>
                  <A
                    href={summary.company.path}
                    decoration="none"
                    target="_blank"
                  >
                    {summary.company.name}
                  </A>
                </TableCell>
                <TableCell align="center">
                  {summary.preIpoNumOfStocks &&
                    formatWithComma(summary.preIpoNumOfStocks, {
                      decimalPlace: 1,
                    })}
                </TableCell>
                <TableCell align="center">{summary.share}%</TableCell>
                <TableCell align="center">
                  {summary.totalInvestment &&
                    formatWithComma(summary.totalInvestment)}
                </TableCell>
                <TableCell align="center">
                  {summary.stockAverage &&
                    formatWithComma(summary.stockAverage, { decimalPlace: 2 })}
                </TableCell>
                <TableCell>{summary.remark}</TableCell>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <EmptyCard />
      )}
    </Card>
  )
}
